import React from 'react';
import { Link } from 'react-router-dom';
import { FaPhoneAlt, FaFacebookF, FaInstagram } from 'react-icons/fa';
import logo from '../assets/logo.jpg'; // Reuse the same logo for consistency

const Footer = () => (
  <footer className="footer">
    {/* Top Contact Bar */}


    {/* Footer Main */}
    <div className="footer-main">
      <div className="footer-logo">
        <img src={logo} alt="Sprao Technologies Logo" />
        <p>Empowering Digital Transformation</p>
      </div>

      <div className="footer-links">
        <Link to="/about">About Us</Link>
        <Link to="/courses">Courses</Link>
        <Link to="/students">Students</Link>
        <Link to="/contactus">Contact Us</Link>
        <Link to="/reviews">Reviews</Link>
      </div>

      <div className="footer-contact">
        <p>Email: info@spraotechnologies.com</p>
        <p>Address: Hyderabad, Telangana, India</p>
      </div>
    </div>

    {/* Footer Bottom */}
    <div className="footer-bottom">
      <p>&copy; 2025 Sprao Technologies. All rights reserved.</p>
    </div>
  </footer>
);

export default Footer;